import React, { useRef, useState, useEffect } from 'react';
import './App.css';

const App = () => {

  // for focusing on add todo input
  const inputData = useRef(null)

  const [inputTodos, setInputTodos] = useState('')
  const [listTodos, setListTodos] = useState([])

  const [todoId, setTodoId] = useState(null)
  const [editValue, setEditValue] = useState('')


  useEffect(() => {
    const todoJSON = localStorage.getItem('todos')
    const loadTodos = JSON.parse(todoJSON)

    loadTodos && setListTodos(loadTodos)
  }, [])

  useEffect(() => {
    const todoJSON = JSON.stringify(listTodos)
    localStorage.setItem('todos', todoJSON)
  }, [listTodos])

  // ============================== //

  const onInputChange = (e) => {
    setInputTodos(e.target.value)
  }

  // ============================== //

  const onFormSubmit = (e) => {
    e.preventDefault()

    const todos = {
      id: new Date().getTime(),
      text: inputTodos
    }

    setListTodos([...listTodos, todos])

    setInputTodos('')
    inputData.current.focus()
  }

  // ============================== //

  const deleteTodo = (id) => {
    const todos = [...listTodos].filter(todo => todo.id !== id)
    setListTodos(todos)
  }

  // ============================== //

  const getTodoId = (id) => {
    setTodoId(id)

    const todo = listTodos.filter(item => item.id === id)
    setEditValue(todo[0].text)
  }

  // ============================== //

  const updateTodo = (id) => {

    const todos = [...listTodos].map((todo) => {
      if (todo.id === id) {
        todo.text = editValue
      }
      return todo
    })

    setListTodos(todos)
    setTodoId(null)
    setEditValue('')
  }

  // ============================== //

  const onEditValueChange = (e) => {
    setEditValue(e.target.value)
  }

  return (
    <div className="todo-container">
      <h1 className="title">The Amazing Todo List App ✎</h1>
      <div className="form-container">
        <form onSubmit={(e) => onFormSubmit(e)} className="form">
          <input className="todo-input" type="text" onChange={(e) => onInputChange(e)} value={inputTodos} ref={inputData} required />
          <button className="add-todo-btn" type="submit">Add Todo</button>
        </form>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th className="todo-heading">Todos</th>
            <th className="todo-sub-heading">What to do?</th>
          </tr>
        </thead>
        {
          listTodos.map(list => {
            return (
              <tbody key={list.id}>
                <tr>
                  {
                    todoId === list.id
                      ?
                      <td>
                        <input className="edit-input" type="text" onChange={(e) => onEditValueChange(e)} value={editValue} />
                      </td>
                      :
                      <td >
                        &nbsp;&nbsp;
                        {
                          list.text
                        }
                      </td>
                  }
                  {
                    todoId !== list.id
                      ?
                      <td>
                        <button className="edit-todo-btn" onClick={() => getTodoId(list.id)}>Edit</button>
                        <button className="delete-todo-btn" onClick={() => deleteTodo(list.id)}>Delete</button>
                      </td>
                      :
                      <td>
                        <button className="update-todo-btn" onClick={() => updateTodo(list.id)}>Update</button>
                        <button className="cancel-todo-btn" onClick={() => setTodoId(null)}>Cancel</button>
                      </td>
                  }
                </tr>
              </tbody>
            )
          })
        }
      </table>

    </div>
  );
}

export default App;
